let TransitionContainerViolation = /*#__PURE__*/function (TransitionContainerViolation) {
  TransitionContainerViolation["MissingContextProvider"] = "<TransitionContainer /> component was rendered without a parent <TransitionGroupManager />.";
  TransitionContainerViolation["NotShared"] = "<TransitionContainer /> component was rendered with a <TransitionGroupManager /> context value that is already being consumed by a <TransitionContainer /> component higher up in the tree. Was this intentional? If so, pass the `sharedTransition` prop to the <TransitionContainer> component where this warning originated";
  return TransitionContainerViolation;
}({});
class TransitionGroupManagerError extends Error {
  constructor(violation) {
    super(`A <TransitionContainer /> component was rendered incorrectly. Violation: ${violation}`);
    this.violation = violation;
  }
}
function filterUnsupportedClassNames(styles) {
  const filteredStyles = {};
  Object.keys(styles).forEach(style => {
    if (typeof styles[style] === 'string' || styles[style] instanceof String) {
      filteredStyles[style] = styles[style];
    }
  });
  return Object.keys(filteredStyles).length > 0 ? filteredStyles : undefined;
}
function formatTransitionClassNames(styles) {
  return {
    appear: styles.appear,
    appearActive: styles.appearActive,
    appearDone: styles.appearDone,
    enter: styles.enter,
    enterActive: styles.enterActive,
    enterDone: styles.enterDone,
    exit: styles.exit,
    exitActive: styles.exitActive,
    exitDone: styles.exitDone
  };
}

export { TransitionContainerViolation, TransitionGroupManagerError, filterUnsupportedClassNames, formatTransitionClassNames };
